/* eslint no-template-curly-in-string: 0 */
import venmoIcon from '../../assets/images/venmo-icon.svg';
import venmoLogo from '../../assets/images/venmo-logo.png';
import { FLOW_TYPES, PAYMENT_NETWORKS, PAYMENT_STATUSES } from "../../utils/enums";

export const venmo = {
  id: PAYMENT_NETWORKS.VENMO,
  displayName: "Venmo™",
  paywall: {
    tile: {
      displayName: "Venmo™",
      tagline: ["Immediately available funds"],
      description: [
        {
          string: "Use balance for in-app payments",
          type: "div",
        },
        {
          string: "or bank transfer",
          type: "div"
        }
      ],
      // btnLabel: "Next",
      logo: venmoIcon
    }
  },
  acceptPayment: {
    imgSrc: venmoLogo,
    secondaryText: [
      {
        string: 'If you do not have a Venmo™ account, you will receive a text message to create an account and claim your payment. For more information regarding Venmo™ and creating an account, please refer to the FAQs, or visit <a href=\'https://venmo.com\'>https://venmo.com</a>.',
        props: {
          style: { fontSize: 14, lineHeight: 1, color: 'gray', fontStyle: 'italic' }
        }
      }
    ],
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.TWO_FACTOR,
    twoFactor: {
      type: 'phone_number',
      getId: {
        description: [
          'Please enter the phone number associated with your ',
          {
            string: "${paymentNetwork.displayName}",
            props: {
              className: 'payment-paymentNetwork'
            }
          },
          ' account.',
        ],
        // secondaryText: 'You will receive an SMS text message with a one-time code to confirm successful delivery to your mobile device.'
      },
      confirmId: {
        description: [
          "Verify your phone number is correct and tied to your Venmo account. An error in your phone number can result in a lost or non-recoverable payment."
        ],
        confirmationText: [
          "I understand and confirm this is the correct number for my Venmo account.",
        ]
      }
      // getCode: {
      //   description: [
      //     'Please enter the code that was sent to ',
      //     {
      //       string: '${id}',
      //       props: {
      //         className: 'payment-recipientEmail'
      //       }
      //     },
      //     ". This code will expire in 15 minutes."
      //   ],
      // },
    },
    title: 'Receive with Venmo™',
    description: [
      "Please enter the 10-digit mobile number associated with your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork'
        }
      },
      " account."
    ],
    secondaryText: [
      {
        string: 'If you do not have a Venmo™ account, you will receive a text message to create an account and claim your payment. For more information regarding Venmo™ and creating an account, please refer to the FAQs, or visit <a href=\'https://venmo.com\'>https://venmo.com</a>.',
        props: {
          style: { fontSize: 14, lineHeight: 1, color: 'gray', fontStyle: 'italic' }
        }
      }
    ],
  },
  paymentComplete: {
    imgSrc: venmoLogo,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "Signing up for an account, transfer to bank, etc...",
          question: "About Venmo®?"
        }
      ]
    }
  },
  onHold: {
    imgSrc: venmoLogo,
  }
};

export default venmo;
